jQuery(document).ready(function ($) {
  let $targets = $('.prevent-scroll-target');
  let $activators = $('.prevent-scroll-on-active');

  $activators.each(function () {
    let $activator = $(this);
    let opts = new Opts($activator);

    if (opts.mobileOnly && !isMobileNav()) return;

    let $id = findPsIdOfEl($activator);
    let interval = null;

    let $target = null;
    $targets.each(function () {
      let $t = $(this);

      if (findPsIdOfEl($t) === $id) {
        $target = $t;
      }
    });

    if ($target) {
      interval = setInterval(() => {
        if (
          $activator.css('display') !== 'none' &&
          !$target.hasClass('overflow-hidden')
        ) {
          $target.addClass('overflow-hidden');
        } else if (
          $activator.css('display') === 'none' &&
          $target.hasClass('overflow-hidden')
        ) {
          $target.removeClass('overflow-hidden');
        }
      }, 50);
    }
  });
});

function findPsIdOfEl($el) {
  return getClassList($el)
    .filter((_class) => _class.includes('psid'))[0]
    .split('psid-')[1];
}

class Opts {
  constructor($activator) {
    this.mobileOnly = false;

    const classList = getClassList($activator);
    if (classList.includes('prevent-scroll-mobile-only')) {
      this.mobileOnly = true;
    }
  }
}

/**
 *
 * @param {JQueryElement} $el
 * @returns {string[]}
 */
function getClassList($el) {
  return $el.attr('class').split(' ');
}

function isMobileNav() {
  return jQuery(window).width() < 900;
}
